import { render, staticRenderFns } from "./Actualite.vue?vue&type=template&id=f511dbc6&"
import script from "./Actualite.vue?vue&type=script&lang=js&"
export * from "./Actualite.vue?vue&type=script&lang=js&"
import style0 from "./Actualite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports